import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { useAuthentication } from "../../context/authentication";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  makeStyles,
  Container
} from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export const Login = () => {
  const { push } = useHistory();
  const { doLogin, user } = useAuthentication();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });
  const classes = useStyles();


  const onSubmit = async () => {
    const { email, password } = formValues;

    try {
      setIsSubmitting(true);

      await doLogin(email, password);

      push("/");
    } catch (e) {
      console.log(e)
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  return (
     <Container component="main" maxWidth="xs">
     <CssBaseline />
     <div className={classes.paper}>
       <Avatar className={classes.avatar}>
         <LockOutlinedIcon />
       </Avatar>
       <Typography component="h1" variant="h5">
         Sign in
       </Typography>
       <form className={classes.form} noValidate>
         <TextField
           variant="outlined"
           margin="normal"
           required
           fullWidth
           id="email"
           label="Email Address"
           name="email"
           autoComplete="email"
           autoFocus
           value={formValues.email}
           onChange={handleChange}

         />
         <TextField
           variant="outlined"
           margin="normal"
           required
           fullWidth
           name="password"
           label="Password"
           type="password"
           id="password"
           autoComplete="current-password"
           value={formValues.password}
           onChange={handleChange}

         />
         <Button
           fullWidth
           variant="contained"
           color="primary"
           className={classes.submit}
           disabled={isSubmitting}
           onClick={onSubmit}
         >
          {isSubmitting ? "logging..." : "login"}
         </Button>
         {/* <Grid container>
           <Grid item>
             <Link to="/register" variant="body2">
               {"Don't have an account? Sign Up"}
             </Link>
           </Grid>
         </Grid> */}
       </form>
     </div>
     <Box mt={8}>
       <Copyright />
     </Box>
   </Container>
  );
};
